import React, { RefObject } from "react";
import { Button, Toggle } from "rsuite";
import { CronEditor } from "../cron/CronEditor";
import { AVAILABILITY_TYPES, AvailabilityTimeslotData } from "./utils";
import { Updater, useImmer } from "use-immer";
import { CronData } from "../cron/utils";
import TrashIcon from '@rsuite/icons/Trash';
import 'rsuite/Button/styles/index.css';

export const Editor: React.FC<{
  availabilityDataRef: RefObject<AvailabilityTimeslotData | null>;
}> = ({
  availabilityDataRef,
}) => {
  const [availabilityData, setAvailabilityData] = useImmer<AvailabilityTimeslotData | null>(availabilityDataRef.current);

  if (!availabilityData) return <></>;

  const setCronData : Updater<CronData> = (update) => {
    setAvailabilityData((draft) => {
      const newData = { ...draft, cronData: update(draft.cronData) }
      availabilityDataRef.current = newData;
      return newData
    });
  }

  function setTo(
    checkedValue: Partial<AvailabilityTimeslotData>, 
    unCheckedValue?: Partial<AvailabilityTimeslotData>
  ) {
    return (checked: boolean) => {
      setAvailabilityData((draft) => {
        const newData = checked ? 
          { ...draft, ...checkedValue } : 
          { ...draft, ...unCheckedValue };
        availabilityDataRef.current = newData;
        return newData
      });
    }
  }
  
  return <div className="flex flex-col">
    
    <div className="flex flex-row justify-between space-x-8">
      <Toggle
        data-testid="availability-toggle"
        color="green" 
        checked={availabilityData.type === AVAILABILITY_TYPES.available}
        checkedChildren="Available"
        unCheckedChildren="Unavailable"
        onChange={setTo({ type: AVAILABILITY_TYPES.available }, { type: AVAILABILITY_TYPES.unavailable })}
      />
      <Toggle 
        color="red" 
        checked={availabilityData._destroy || false}
        onChange={setTo({ _destroy: true }, { _destroy: false })}
        checkedChildren={<TrashIcon />}
        unCheckedChildren={<TrashIcon />}
      ></Toggle>
    </div>
    <br />
    <CronEditor
      cronData={availabilityData.cronData}
      setCronData={setCronData}
    ></CronEditor>
  </div>
}
